import React, { useEffect, useState } from 'react';
import InvoiceDocument from '../../shared/documents/InvoiceDocument';
import './ContaAplicataLeftPanel.css';

// Ajusteaza calea InvoiceDocument in functie de locul unde salvezi componenta.
export default function ContaAplicataLeftPanel({
  step,
  invoice,
  highlightField = '',
  stepIndex = 0,
}) {
  const [page, setPage] = useState(0);

  // La un exercitiu nou, afiseaza intotdeauna contextul.
  useEffect(() => {
    setPage(0);
  }, [stepIndex]);

  const context = step?.context || {};
  const contextTitle = typeof context === 'string'
    ? 'Contextul operatiunii'
    : context.title || 'Contextul operatiunii';
  const contextDescription = typeof context === 'string'
    ? context
    : context.description || '';
  const requirement = step?.requirement || '';
  const documentTitle = step?.document?.title || 'Document justificativ';

  return (
    <section className="calp" aria-label="Context si document">
    

      <div className="calp__content">
        {page === 0 ? (
          <div className="calp__context">
           
            <h2>{contextTitle}</h2>
            {contextDescription ? (
              <p>{contextDescription}</p>
            ) : (
              <p>Contextul acestui exercitiu nu este disponibil.</p>
            )}
            <div className="calp__requirement">
              <h3>Cerinta</h3>
              <p>{requirement || 'Cerinta nu este disponibila.'}</p>
            </div>
          </div>
        ) : (
          <div className="calp__document">
            {invoice ? (
              <InvoiceDocument
                invoice={invoice}
                highlightField={highlightField}
              />
            ) : (
              <p className="calp__empty">
                Pentru acest pas nu exista un document.
              </p>
            )}
          </div>
        )}
      </div>

      <nav className="calp__nav" aria-label="Navigare panou stang">
        <button
          type="button"
          onClick={() => setPage(0)}
          disabled={page === 0}
          aria-label="Afiseaza contextul"
        >
          <span aria-hidden="true">←</span> Context
        </button>
        <span className="calp__counter" aria-live="polite">
          {page + 1} / 2
        </span>
        <button
          type="button"
          onClick={() => setPage(1)}
          disabled={page === 1}
          aria-label="Afiseaza documentul"
        >
          Document <span aria-hidden="true">→</span>
        </button>
      </nav>
    </section>
  );
}
